import React from "react";
import { Trait } from "types";

export type TraitsContextValue = {
  traits: Trait[];
  traitsByTokenId: Record<number, Trait>;
  fetchTraits: () => void;
  isLoading: boolean;
};

const TraitsContext = React.createContext<TraitsContextValue>({
  traits: [],
  traitsByTokenId: {},
  fetchTraits: () => {},
  isLoading: false,
});

export default TraitsContext;
